/** @deprecated This is the old color scheme, before we had a design system, do not use it.
 *  See components-stateless/DesignSystem/Atoms/Colours for the current values */
export const COLORS = {
  INTEGRATIONS_GREEN: '#71B22F',
  GREEN: '#17BA86',
  LIGHT_GREEN: '#1BDA9D',
  DARK_GREEN: '#10825D',

  RED: '#EF5B5B',
  ERROR_RED: '#F44336',
  ORANGE: '#EAAB46',

  TEAL: '#00CCBD',
  LIGHT_TEAL: '#00E2D2',
  DARK_TEAL: '#00A99D',

  BLUE_STEEL: '#2F4858',
  STEEL: '#252C35',
  CHARCOAL: '#2D2F30',
  BORDER_GREY: '#CCCCCC',

  LIGHT_BLUE: '#42A5F5',
  NAVY_BLUE: '#4676B4',
  MEDIUM_BLUE: '#2D3B55',
  SHADOW_BLUE: '#EFF3F7',

  PURPLE: '#857EC9',

  DARK_GREY: '#34373a',
  NICE_GREY: '#D3D3D3',
  GREY: '#A0A4B8',
  LIGHT_GREY: '#D7D9CE',
  MATERIAL_LABEL_GREY: 'rgba(0,0,0,0.54)',
  MEDIUM_GREY: '#C1C3C9',

  BLACK: '#040404',
  ICON_BLACK: 'rgba(0, 0, 0, 0.84)',
  WHITE: '#FFFFFF',
  OFF_WHITE: '#F2F2F2',
  WHITE_GREY: '#FAFAFA',
  STUDIO_STENCIL_GREY: '#757575',

  // COLOURS FROM NEW UI/MOCKUPS
  BACKGROUND_GREY: '#EDF1F5',
  TEXT_GREY: '#51627B',
} as const;

/** @deprecated This was an old draft of the design system, do not use it. See
 * components-stateless/DesignSystem/Atoms/Colours for the current values */
export const NEW_DESIGN_SYS_COLORS = {
  BUTTON_TEXT_GREY: '#1E314C',
  LABEL_GREY: '#51627B',
  BUTTON_TEXT_GREEN: '#16b582',
  TABLE_GRID_BORDER_LIGHT_GREY: '#E5EDF6',
  DISABLED_ICON_GREY: '#A2A2A3',
  CELL_BACKGROUND_GREY: '#f7fafd',
  NEUTRAL_GREY: '#E5EDF6',
  WHITE: '#FFF',
  RED: '#EF5B5B',
} as const;
